import { useQuery } from '@tanstack/react-query';

import { apiErrorMessage } from '../../shared/api/errors';
import { formatDateTime } from '../../shared/lib/format';
import { Card, EmptyState, ErrorText, PageHeader, Spinner } from '../../shared/ui/primitives';
import { listPartnershipRequests } from '../partnership/api';

/** Заявки «Сотрудничество» из публичной формы, новые сверху. */
export function PartnershipRequestsPage() {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['admin', 'partnership-requests'],
    queryFn: listPartnershipRequests,
  });

  return (
    <section className="space-y-5">
      <PageHeader title="Заявки на сотрудничество" />

      {isLoading && <Spinner />}
      {isError && <ErrorText>{apiErrorMessage(error)}</ErrorText>}
      {data && data.items.length === 0 && <EmptyState>Заявок пока нет.</EmptyState>}

      {data && data.items.length > 0 && (
        <Card className="divide-y divide-line overflow-hidden">
          {data.items.map((r) => (
            <div key={r.id} className="space-y-1 px-4 py-3">
              <div className="flex flex-wrap items-baseline justify-between gap-2">
                <p className="font-medium text-ink">{r.fullName}</p>
                <span className="text-xs text-muted">{formatDateTime(r.createdAt)}</span>
              </div>
              <p className="text-sm text-muted">
                <a href={`tel:${r.phone}`} className="text-accent hover:text-accent-600">
                  {r.phone}
                </a>
                {r.email && (
                  <>
                    {' · '}
                    <a href={`mailto:${r.email}`} className="text-accent hover:text-accent-600">
                      {r.email}
                    </a>
                  </>
                )}
                {[r.clinic, r.city].filter(Boolean).map((s) => ` · ${s}`)}
              </p>
              {r.comment && <p className="whitespace-pre-line text-sm text-ink">{r.comment}</p>}
            </div>
          ))}
        </Card>
      )}
    </section>
  );
}
